import React, { useEffect, useState } from "react";
import "./cssportfolio.css";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { baseURL } from "../../App";
import i18n from "../../i18n/config";

import SkeletonLoader from "../Skeleton/SkeletonLoader";

export const Portfolio = () => {
  const { t } = useTranslation();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/portfolio`);
        setProjects(response.data);
      } catch (err) {
        setError("Error fetching projects");
        console.error("Error fetching projects:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  if (loading) {
    return (
      <section id="portfolio">
        <h5>{t("projects.sub_title")}</h5>
        <h2>{t("projects.title")}</h2>
        <SkeletonLoader type="portfolio" count={3} />
      </section>
    );
  }
  if (error) return <p>{error}</p>;

  return (
    <section id="portfolio">
      <h5>{t("projects.sub_title")}</h5>
      <h2>{t("projects.title")}</h2>

      <div className="container portfolio_container">
        {projects.map(
          ({
            id,
            image,
            titleFr,
            titleEn,
            github,
            demo,
            descriptionFr,
            descriptionEn,
          }) => {
            return (
              <article key={id} className="portfolio_item">
                <div className="portfolio_item_image">
                  <img src={image} alt={titleEn} />
                </div>
                <h3>{i18n.language === "en" ? titleEn : titleFr}</h3>
                <span>
                  {i18n.language === "en" ? descriptionEn : descriptionFr}
                </span>
                <div className="portfolio_item_cta">
                  <a
                    href={github}
                    className="btn"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github
                  </a>
                  <a
                    href={demo}
                    className="btn btnPrimary"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t("vistite_site")}
                  </a>
                </div>
              </article>
            );
          },
        )}
      </div>
    </section>
  );
};

export default Portfolio;
